<panel width="800">
	<h1>{{ 'order-pipeline.title' | translate }}</h1>
	@if (loading) {
		<skeletons [defaultSkeletons]="5" />
	}
	@else {
		<list-view scrollable emptyLabel="order-pipeline.empty">
			<header>{{ 'general.column.order-number' | translate }}</header>
			<header defaultSort="ascending">{{ 'order-pipeline.approved-date' | translate }}</header>
			<header>{{ 'general.column.company-name' | translate }}</header>
			<header align-right>{{ 'order-pipeline.acv' | translate }}</header>
			<header align-right>{{ 'order-pipeline.tcv' | translate }}</header>
			<header align-right>{{ 'order-pipeline.delivered' | translate }}</header>
			<header>{{ 'order-pipeline.auto-delivery' | translate }}</header>
			<row *listData="let order from orders"
				[select]="selectedOrder == order"
				(action)="displayOrder(order)">
				<column>{{ order.referenceNumber }}</column>
				<column [sortValue]="order.approvedDate">{{ order.approvedDate | customDate: 'shortDate' }}</column>
				<column>{{ order.company && order.company.name != '' ? order.company.name : ('general.na' | translate) }}</column>
				<column align-right [sortValue]="getAcv(order)">{{ getAcv(order) | currency }}</column>
				<column align-right [sortValue]="salesService.getTotalPrice(order)">{{ salesService.getTotalPrice(order) | currency }}</column>
				<column align-right>{{ getDeliveredCount(order) }}/{{ getTotalCount(order) }}</column>
				<column align-right>{{ (order.autoDelivery ? 'general.true' : 'general.false') | translate }}</column>
			</row>
		</list-view>
	}
</panel>
